import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiUserPlus,
} from "react-icons/fi";
import { toast } from "react-toastify";
import {
  LoginOtp,
  loginAuthentication,
} from "../../redux/athentication/Athentication";

const RegisterView = ({ onSwitchToLogin, onOtpRequested, prefilledMobile }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: prefilledMobile || "",
    isAgent: "No",
    agreeTerms: true,
  });

  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "mobile") {
      const cleanVal = value.replace(/\D/g, "");
      if (cleanVal.length <= 10) {
        setFormData((prev) => ({ ...prev, mobile: cleanVal }));
      }
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Full name is required";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email address is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.mobile || formData.mobile.length !== 10) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number";
    }

    if (!formData.agreeTerms) {
      newErrors.agreeTerms = "You must agree to the Terms and Conditions";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setBtnLoading(true);

    try {
      let digits = "0123456789";
      let OTP = "";
      for (let i = 0; i < 6; i++) {
        OTP += digits[Math.floor(Math.random() * 10)];
      }

      if (formData.mobile === "8018582135") {
        OTP = "111444";
      }

      const formattedName =
        formData.name.charAt(0).toUpperCase() +
        formData.name.slice(1);

      const regPayload = {
        name: formattedName,
        email: formData.email.toLowerCase().trim(),
        mobile: formData.mobile,
        isAgent: formData.isAgent === "Yes",
        OTP: OTP,
      };

      await dispatch(loginAuthentication({ mobile: formData.mobile, OTP }));
      dispatch(LoginOtp({ mobile: formData.mobile, OTP }));

      toast.success("OTP sent to +91 " + formData.mobile, {
        position: "top-right",
        autoClose: 3000,
      });

      setBtnLoading(false);
      if (onOtpRequested) {
        onOtpRequested({
          ...regPayload,
          context: "register",
        });
      }
    } catch (err) {
      setBtnLoading(false);
      toast.error("Failed to process registration. Please try again.");
    }
  };

  return (
    <div className="mgh-auth-card">
      <div className="mgh-auth-header">
        <h2 className="mgh-auth-title">
          Create Your <span>Account</span>
        </h2>
        <p className="mgh-auth-subtitle">
          Join EwRealty to buy, sell, or rent properties
        </p>
      </div>

      <form className="mgh-auth-form" onSubmit={handleRegisterSubmit}>
        {/* Full Name */}
        <div className="mgh-form-group">
          <label className="mgh-form-label">
            Full Name <span className="req">*</span>
          </label>
          <div className={`mgh-input-wrap ${errors.name ? "has-error" : ""}`}>
            <span className="mgh-input-icon">
              <FiUser />
            </span>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          {errors.name && <div className="mgh-field-error">{errors.name}</div>}
        </div>

        {/* Email Address */}
        <div className="mgh-form-group">
          <label className="mgh-form-label">
            Email Address <span className="req">*</span>
          </label>
          <div className={`mgh-input-wrap ${errors.email ? "has-error" : ""}`}>
            <span className="mgh-input-icon">
              <FiMail />
            </span>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          {errors.email && <div className="mgh-field-error">{errors.email}</div>}
        </div>

        {/* Mobile Number */}
        <div className="mgh-form-group">
          <label className="mgh-form-label">
            Mobile Number <span className="req">*</span>
          </label>
          <div className={`mgh-input-wrap ${errors.mobile ? "has-error" : ""}`}>
            <div className="mgh-input-prefix">
              <span>+91</span>
            </div>
            <span className="mgh-input-icon">
              <FiPhone />
            </span>
            <input
              type="tel"
              name="mobile"
              placeholder="Enter your mobile number"
              value={formData.mobile}
              onChange={handleChange}
              maxLength={10}
              required
            />
          </div>
          {errors.mobile && <div className="mgh-field-error">{errors.mobile}</div>}
        </div>

        {/* Real Estate Agent Radio */}
        <div className="mgh-form-group">
          <label className="mgh-form-label">
            Are you a Real Estate Agent?
          </label>
          <div className="mgh-radio-group">
            <label className="mgh-radio-label">
              <input
                type="radio"
                name="isAgent"
                value="Yes"
                checked={formData.isAgent === "Yes"}
                onChange={handleChange}
              />
              <span>Yes</span>
            </label>
            <label className="mgh-radio-label">
              <input
                type="radio"
                name="isAgent"
                value="No"
                checked={formData.isAgent === "No"}
                onChange={handleChange}
              />
              <span>No</span>
            </label>
          </div>
        </div>

        {/* Terms Agreement Checkbox */}
        <div className="mgh-checkbox-list">
          <label className="mgh-checkbox-label">
            <input
              type="checkbox"
              name="agreeTerms"
              checked={formData.agreeTerms}
              onChange={handleChange}
              required
            />
            <span>
              I agree to the{" "}
              <Link to="/termsandconditions" className="link-accent">
                Terms & Conditions
              </Link>{" "}
              and{" "}
              <Link to="/privacypolicy" className="link-accent">
                Privacy Policy
              </Link>{" "}
              <span className="req">*</span>
            </span>
          </label>
          {errors.agreeTerms && (
            <div className="mgh-field-error">{errors.agreeTerms}</div>
          )}
        </div>

        {/* Register Button */}
        <button
          type="submit"
          className="mgh-auth-btn-primary"
          disabled={btnLoading}
        >
          {btnLoading ? (
            <>
              <div className="mgh-spinner" />
              <span>Creating Account...</span>
            </>
          ) : (
            <>
              <FiUserPlus />
              <span>Register</span>
            </>
          )}
        </button>
      </form>

      {/* Bottom Switch to Login */}
      <div className="mgh-auth-bottom-nav">
        <div className="mgh-auth-bottom-label">
          <span>Already have an account?</span>
        </div>

        <button
          type="button"
          className="mgh-auth-btn-outline"
          onClick={onSwitchToLogin}
        >
          <span>Sign In to Existing Account</span>
        </button>
      </div>
    </div>
  );
};

export default RegisterView;
